__turbopack_context__.v({
  "deadEnd": "mSaipq_deadEnd",
  "deadEndActions": "mSaipq_deadEndActions",
  "deadEndBody": "mSaipq_deadEndBody",
  "deadEndTitle": "mSaipq_deadEndTitle",
  "doorLabel": "mSaipq_doorLabel",
  "emptyStack": "mSaipq_emptyStack",
  "linkedinPath": "mSaipq_linkedinPath",
  "linkedinSteps": "mSaipq_linkedinSteps",
  "linkedinStepsIcon": "mSaipq_linkedinStepsIcon",
  "panel": "mSaipq_panel",
  "privacyNote": "mSaipq_privacyNote",
  "progressFill": "mSaipq_progressFill",
  "progressTrack": "mSaipq_progressTrack",
  "quietButton": "mSaipq_quietButton",
  "reading": "mSaipq_reading",
  "readingMeta": "mSaipq_readingMeta",
  "readingText": "mSaipq_readingText",
  "readingTitle": "mSaipq_readingTitle",
  "spin": "mSaipq_spin",
  "spinner": "mSaipq_spinner",
});
